export const REQUIRED = 'REQUIRED';
export const STRING_INVALID = 'STRING_INVALID';
export const MAX_STRING_SIZE = 255;
export const URL_INVALID = 'URL_INVALID';
